import React from 'react';
import './V1ProblemSection.css';

interface V1ProblemSectionProps {
  theme: 'premium' | 'energetic';
}

const V1ProblemSection: React.FC<V1ProblemSectionProps> = ({ theme }) => {
  const problems = [
    {
      icon: '😰',
      title: 'Stres przed egzaminem',
      description: 'Każda myśl o maturze wywołuje niepokój i panikę'
    },
    {
      icon: '📚',
      title: 'Brak pewności w materiał',
      description: 'Nie wiesz, czy Twoja wiedza wystarczy do zdania'
    },
    {
      icon: '⏰',
      title: 'Obawy o wyniki',
      description: 'Martwisz się, że nie osiągniesz swoich celów'
    }
  ];

  return (
    <section className="v1-problem-section v1-section">
      <div className="v1-container">
        <h2 className="v1-section-title v1-animate-in">
          {theme === 'premium' ? 'Czy to Ci znajome?' : '💭 CZY TO CI ZNAJOME?'}
        </h2>
        <p className="v1-section-subtitle v1-animate-in" style={{ animationDelay: '0.2s' }}>
          {theme === 'premium'
            ? 'Wielu uczniów zmaga się z tymi samymi wyzwaniami przed egzaminem'
            : 'Nie jesteś sam! Wszyscy przez to przechodzą 👇'
          }
        </p>

        <div className="v1-problems-grid">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="v1-problem-card v1-glass v1-animate-in"
              style={{ animationDelay: `${0.4 + index * 0.1}s` }}
            >
              <div className="v1-problem-icon">{problem.icon}</div>
              <h3>{problem.title}</h3>
              <p>{problem.description}</p>
            </div>
          ))}
        </div>

        <div className="v1-problem-cta v1-animate-in" style={{ animationDelay: '0.8s' }}>
          <p className="v1-problem-solution-text">
            <strong>Ale nie musi tak być!</strong> Mamy sprawdzoną metodę, która eliminuje stres i gwarantuje wyniki.
          </p>
        </div>
      </div>
    </section>
  );
};

export default V1ProblemSection;
